var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { AidType } from '@/common/types/AidType';
import MasterDataConsumer from '@/common/mixins/MasterDataConsumer';
import EntityService from '@/common/services/EntityService';
import SingleSelectAccessible from '@/common/components/SingleSelectAccessible.vue';
import { EnumHelpers } from '@/common/mixins/EnumHelpers';
import { Notification } from '@/common/services/notificationService';
var NewApplicationView = /** @class */ (function (_super) {
    __extends(NewApplicationView, _super);
    function NewApplicationView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entityService = new EntityService();
        _this.aidtargets = [];
        _this.aidtargetOptions = [];
        _this.aidTypeOptions = [];
        _this.aidTypeOptionsForB = [];
        _this.aidTypeOptionsForBExtension = [];
        _this.selectedAidType = null;
        _this.selectedBType = null;
        _this.selectedBTypeForExtension = null;
        _this.selectedAidTargetId = null;
        _this.bTypeSetByEarlierApplication = false;
        _this.extensionOptionsRetrieved = false;
        return _this;
    }
    NewApplicationView.prototype.cleanNewApplicationData = function () {
        if (!this.showBDropdownForNewApplication) {
            this.selectedBType = null;
        }
    };
    NewApplicationView.prototype.cleanExtensionApplyData = function () {
        if (!this.showBDropDownForExtension) {
            this.selectedBTypeForExtension = null;
        }
    };
    Object.defineProperty(NewApplicationView.prototype, "aidTypeIdForNewAidApplication", {
        get: function () {
            return this.showBDropdownForNewApplication
                ? this.selectedBType
                : this.selectedAidType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NewApplicationView.prototype, "aidTypeIdForExtensionApplication", {
        get: function () {
            return this.showBDropDownForExtension
                ? this.selectedBTypeForExtension
                : this.selectedAidTarget.aidTypeValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NewApplicationView.prototype, "selectedAidTarget", {
        get: function () {
            var _this = this;
            return this.selectedAidTargetId
                ? this.aidtargets.find(function (x) { return x.id === _this.selectedAidTargetId; })
                : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NewApplicationView.prototype, "showApplyContent", {
        get: function () {
            return this.aidTypeOptions.length != 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NewApplicationView.prototype, "showExtensionApplyContent", {
        get: function () {
            return this.showExtensionApply;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NewApplicationView.prototype, "showBDropdownForNewApplication", {
        get: function () {
            return this.selectedAidType && this.selectedAidType == AidType.B;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NewApplicationView.prototype, "showBDropDownForExtension", {
        get: function () {
            return this.selectedAidTarget != undefined && this.selectedAidTarget.aidType == AidType.B;
        },
        enumerable: false,
        configurable: true
    });
    NewApplicationView.prototype.onAidTargetChanged = function () {
        var target = this.selectedAidTarget;
        if (target) {
            this.bTypeSetByEarlierApplication = target.aidType == AidType.B && !!target.bAidTypeValue;
            this.selectedBTypeForExtension = target.bAidTypeValue;
        }
    };
    Object.defineProperty(NewApplicationView.prototype, "isNewApplicationBtnDisabled", {
        get: function () {
            return this.aidTypeIdForNewAidApplication == null || !this.hasProcuration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NewApplicationView.prototype, "isNewExtensionApplicationBtnDisabled", {
        get: function () {
            return this.selectedAidTarget == undefined || this.aidTypeIdForExtensionApplication == null || !this.hasProcuration;
        },
        enumerable: false,
        configurable: true
    });
    NewApplicationView.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initializeOptionLists()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NewApplicationView.prototype.startNewAidApplication = function () {
        if (this.aidTypeIdForNewAidApplication) {
            this.$router.push({ name: "organisation-information", params: { aidType: this.aidTypeIdForNewAidApplication.toString(), aidTargetId: null } });
        }
    };
    NewApplicationView.prototype.startNewExtensionApplication = function () {
        var aidtarget = this.selectedAidTarget;
        if (aidtarget) {
            this.$router.push({ name: "organisation-information", params: { aidType: this.aidTypeIdForExtensionApplication.toString(), aidTargetId: aidtarget.aidTargetId } });
        }
    };
    NewApplicationView.prototype.initializeOptionLists = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initNewApplicationData()];
                    case 1:
                        _a.sent();
                        this.initializeAidTypes();
                        this.initializeAidTypesForB();
                        if (!this.showExtensionApply) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.initializeAidTargetsForExtensionApply()];
                    case 2:
                        _a.sent();
                        this.initializeAidTypesForBExtension();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NewApplicationView.prototype.initializeAidTypes = function () {
        var types = this.applicationTypes;
        if (types) {
            var options = types
                .filter(function (type) { return type.aidType != AidType.B; })
                .map(function (type) {
                return {
                    id: type.aidTypeValue,
                    name: "AidApplicationType." + type.aidTypeKey
                };
            });
            if (types.some(function (type) { return type.aidType == AidType.B; })) {
                options.push({
                    id: AidType.B,
                    name: "AidApplicationType.B"
                });
            }
            this.aidTypeOptions = options;
        }
    };
    /**
     * Note! This initializes the B sub types based on the application types that were
     * received from the server. Included types are filtered by the application's settings.
     * */
    NewApplicationView.prototype.initializeAidTypesForB = function () {
        var bTypes = this.applicationTypes
            .filter(function (type) { return type.aidType == AidType.B; });
        if (bTypes) {
            var optionsArrayForB = bTypes
                .map(function (type) {
                return {
                    id: type.aidTypeValue,
                    name: "Enums.BOptions." + type.aidTypeValue
                };
            });
            this.aidTypeOptionsForB = optionsArrayForB;
        }
    };
    /**
     * Note! This initializes the B sub types based the BAidType enumerable.
     * This is needed because we choose to close ordinary applications but allow
     * extension applications.
     * */
    NewApplicationView.prototype.initializeAidTypesForBExtension = function () {
        this.aidTypeOptionsForBExtension = this.optionsArray("BOptions");
    };
    NewApplicationView.prototype.initializeAidTargetsForExtensionApply = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        this.extensionOptionsRetrieved = false;
                        _a = this;
                        return [4 /*yield*/, this.entityService.getAidTargetsForExtension()];
                    case 1:
                        _a.aidtargets = _b.sent();
                        if (this.aidtargets) {
                            this.aidtargetOptions = this.aidtargets.map(function (x) { return ({ id: x.id, name: x.number + " - " + x.purpose }); });
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _b.sent();
                        console.error(e_1);
                        Notification.error(this, this.$t("FetchFailed").toString());
                        return [3 /*break*/, 4];
                    case 3:
                        this.extensionOptionsRetrieved = true;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(NewApplicationView.prototype, "hasProcuration", {
        get: function () {
            var user = this.$store.state.vuexPageModule.currentUser;
            if (user) {
                return user.hasProcuration;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Watch("selectedAidType"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NewApplicationView.prototype, "cleanNewApplicationData", null);
    __decorate([
        Watch("selectedAidTargetId"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NewApplicationView.prototype, "cleanExtensionApplyData", null);
    __decorate([
        Watch("selectedAidTargetId"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], NewApplicationView.prototype, "onAidTargetChanged", null);
    NewApplicationView = __decorate([
        Component({
            name: 'NewApplicationView',
            components: {
                SingleSelectAccessible: SingleSelectAccessible
            }
        })
    ], NewApplicationView);
    return NewApplicationView;
}(Mixins(MasterDataConsumer, EnumHelpers)));
export default NewApplicationView;
